import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AppOnlyFeatureService } from '../app-only-feature/app-only-feature.service';

@Injectable()
export class AppOnlyFeatureGuard implements CanActivate {

	constructor(
		private router: Router,
		private appOnlyFeatureService: AppOnlyFeatureService) {
	}

	canActivate(next: ActivatedRouteSnapshot): boolean {
		this.appOnlyFeatureService.openNotice(next.data.appOnlyFeatureText);
		this.router.navigate(['']);
		return false;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/guards/app-only-feature.guard.ts